import type React from 'react';
import { Header } from '../components/Header';
import { type DrawerContentData, RightDrawer } from '../components/RightDrawer';
import { Sidebar } from '../components/Sidebar';
import { useAuth } from '../contexts/AuthContext';
import { AppRoutes } from './AppRoutes';
import styles from './App.module.css';

interface AuthenticatedLayoutProps {
  rightDrawerOpen: boolean;
  rightDrawerContent: DrawerContentData | null;
  onOpenRightDrawer: (content: DrawerContentData) => void;
  onCloseRightDrawer: () => void;
}

export const AuthenticatedLayout: React.FC<AuthenticatedLayoutProps> = ({
  rightDrawerOpen,
  rightDrawerContent,
  onOpenRightDrawer,
  onCloseRightDrawer,
}) => {
  const { isAuthenticated } = useAuth();

  return (
    <>
      {isAuthenticated && <Sidebar />}
      <main className={styles.mainContent} data-authenticated={isAuthenticated} data-drawer-open={rightDrawerOpen}>
        <Header onOpenRightDrawer={onOpenRightDrawer} rightDrawerOpen={rightDrawerOpen} />
        <div className={styles.contentArea}>
          <AppRoutes onOpenRightDrawer={onOpenRightDrawer} />
        </div>
      </main>
      <RightDrawer isOpen={rightDrawerOpen} content={rightDrawerContent} onClose={onCloseRightDrawer} />
    </>
  );
};
